import warning from 'warning';
var warned = {};
export default (function (valid, component, message) {
  if (!valid && !warned[message]) {
    warning(false, "[antd: ".concat(component, "] ").concat(message));
    warned[message] = true;
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/warning.js
// module id = 22
// module chunks = 57